import { BodilFont, NorlysFont } from '~src/branding';
import { formatCurrency } from '~src/util';

import { LegendIcon, LegendWrapper, Row, TextWrapper } from './style';
import { LegendsProps } from './types';

const LegendCommon = ({
  entries,
  direction = 'row',
  textStyle = BodilFont.style('default', 12),
  numberStyle = BodilFont.style('default', 14),
  style,
}: LegendsProps) => {
  const isColumn = direction === 'column';

  return (
    <LegendWrapper {...{ direction, style }}>
      {entries.map(({ heading, value, iconColor, valueColor }) => (
        <Row key={`entry-${heading}`}>
          {!!iconColor && <LegendIcon color={iconColor} />}
          <TextWrapper {...{ dir: isColumn ? 'row' : 'column' }}>
            <div {...{ style: { ...textStyle, whiteSpace: 'nowrap' } }}>{heading}</div>
            {value && (
              <div {...{ style: { ...numberStyle, color: valueColor, placeSelf: 'right', whiteSpace: 'nowrap' } }}>
                {formatCurrency(value, { decimals: 0 })}
              </div>
            )}
          </TextWrapper>
        </Row>
      ))}
    </LegendWrapper>
  );
};

export const Legend = (props: LegendsProps) => <LegendCommon {...props} />;

export const LegendNorlys = ({ entries, ...rest }: LegendsProps) => (
  <LegendCommon
    {...{
      entries,
      textStyle: NorlysFont.style('default', 12),
      numberStyle: NorlysFont.style('heading', 20),
      ...rest,
    }}
  />
);
